import { trackEvent } from "@/utils/analytics";

export const trackResourceLibraryPageViewed = (): void => {
  trackEvent("resource_library.page_viewed", {
    category: "Resource Library",
    action: "page_viewed",
  });
};

interface ResourceCardClickParams {
  resourceType: string;
  resourceUuid: string;
}

export const trackResourceCardClick = (
  params: ResourceCardClickParams,
): void => {
  trackEvent("resource_library.resource_card_clicked", {
    category: "Resource Discovery",
    action: "resource_card_clicked",
    resource_type: params.resourceType,
    resource_uuid: params.resourceUuid,
  });
};

interface ResourceDetailsViewParams {
  resourceType: string;
  resourceUuid: string;
}

export const trackResourceDetailsView = (
  params: ResourceDetailsViewParams,
): void => {
  trackEvent("resource_library.resource_details_viewed", {
    category: "Resource Details",
    action: "resource_details_viewed",
    resource_type: params.resourceType,
    resource_uuid: params.resourceUuid,
  });
};

export const trackResourceFiltersChanged = (): void => {
  trackEvent("resource_library.resource_filters_changed", {
    category: "Resource Filters",
    action: "resource_filters_changed",
  });
};

interface ResourceViewModeChangedParams {
  viewMode: "card" | "list";
}

export const trackResourceViewModeChanged = (
  params: ResourceViewModeChangedParams,
): void => {
  trackEvent("resource_library.view_mode_changed", {
    category: "Resource Library",
    action: "view_mode_changed",
    view_mode: params.viewMode,
  });
};

interface ResourceSortChangedParams {
  sortOption: "newest" | "oldest" | "mostViewed" | "alphabetical";
}

export const trackResourceSortChanged = (
  params: ResourceSortChangedParams,
): void => {
  trackEvent("resource_library.sort_changed", {
    category: "Resource Library",
    action: "sort_changed",
    sort_option: params.sortOption,
  });
};
